import PropTypes from 'prop-types'

import recentlyCompleted from './recentlyCompleted'

export default PropTypes.arrayOf(recentlyCompleted)
